import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-390c57a7")

_pushScopeId("data-v-390c57a7")
const _hoisted_1 = { class: "fridgedoormonitor-weekly" }
const _hoisted_2 = { class: "fridgedoormonitor-weekly-datesrange" }
const _hoisted_3 = { class: "fridgedoormonitor-weekly-datesrange-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FridgeDoorMonitorWeeklyItem = _resolveComponent("FridgeDoorMonitorWeeklyItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", _hoisted_3, _toDisplayString(_ctx.datesRangeString), 1)
    ]),
    (_ctx.list.length>0)
      ? (_openBlock(), _createBlock("div", {
          class: "fridgedoormonitor-weekly-content",
          ref: "scroll",
          key: _ctx.updateDisplayKey
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.weeklyList, (info) => {
            return (_openBlock(), _createBlock(_component_FridgeDoorMonitorWeeklyItem, {
              class: "fridgedoormonitor-weekly-content-item",
              key: info.list[0].date,
              list: info.list,
              onClickCaution: _ctx.clickCaution
            }, null, 8, ["list", "onClickCaution"]))
          }), 128 /* KEYED_FRAGMENT */))
        ], 512))
      : _createCommentVNode("", true)
  ]))
})